export default class {
  constructor() {
    this.btn = 'hamburger';
  }

  init() {
    $(() => {
      const menuButton = document.getElementById(this.btn);
      const body = document.getElementsByTagName('body')[0];
      const menu = document.getElementsByClassName('navbar-collapse')[0];
      menuButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (!menuButton.classList.contains('is-active')) {
          menuButton.classList.add('is-active');
          body.classList.add('menu-open');
          menu.classList.add('show');
        } else {
          menuButton.classList.remove('is-active');
          body.classList.remove('menu-open');
          menu.classList.remove('show');
        }
      });

      const dropdowns = $("a[data-toggle='dropdown']");
      const navItems = $('.nav-item');
      dropdowns.on({
        click() {
          if (dropdowns.parent().hasClass('show')) {
            dropdowns.parent().removeClass('show');
          } else {
            navItems.removeClass('show');
            dropdowns.parent().addClass('show');
          }
        },
      });
    });
  }
};
